import { ForwardedRef, forwardRef, useImperativeHandle, useRef } from 'react';

import { RightOutlined } from '@ant-design/icons';
import { Flex } from '@revenuemarket/cds';
import { overlays } from '@revenuemarket/overlays';
import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';
import { Button } from 'antd';

import { WireListItem } from '~components/BankWiring/types';
import SettlementTaxInvoiceResultDrawer from '~components/BusinessEntity/SettlementTaxInvoiceResultDrawer';

interface Props extends ICellRendererParams<WireListItem> {}

const AGGridWiringInvoiceRenderer = ({ data }: Props, ref: ForwardedRef<ICellRendererComp>) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => ({
    getGui: () => containerRef.current ?? document.body,
    refresh: () => true,
  }));

  if (data?.taxInvoiceId == null) {
    return null;
  }

  return (
    <Flex ref={containerRef} align="center" style={{ height: '100%' }}>
      <Button
        type="link"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
        onClick={() => {
          if (!data?.taxInvoiceId) {
            return;
          }
          overlays.open(({ isOpen, onClose }) => (
            <SettlementTaxInvoiceResultDrawer
              isOpen={isOpen}
              onClose={onClose}
              id={data.taxInvoiceId as string}
              type="PURCHASE"
            />
          ));
        }}
      >
        세금계산서
        <RightOutlined
          style={{
            width: 16,
          }}
        />
      </Button>
    </Flex>
  );
};

export default forwardRef(AGGridWiringInvoiceRenderer);
